<template>
  <el-aside
    :width="width"
    class="sidebar"
  >
    <div class="main">
      <router-link
        v-if="isSaas"
        tabindex="-1"
        :to="{name: 'home-page'}"
        class="logo"
      >
        <img
          v-if="!collapse"
          class="logoImg"
          src="@assets/logo-text.png"
          alt="zast.ai"
        />
        <img
          v-else
          class="logoImg-s"
          src="@assets/logo.png"
          alt="zast.ai"
        />
      </router-link>
      <div
        v-if="isSaas"
        class="divider"
      />
      <el-menu
        router
        :collapse-transition="false"
        :collapse="collapse"
        :default-active="active"
        class="menu"
      >
        <el-menu-item
          :class="['menuItem', {folder: collapse, unfolder: !collapse}]"
          v-for="item in menus"
          :key="item.index"
          :index="item.index"
          :route="item.route"
        >
          <img
            :src="item.iconImg"
            :alt="item.title"
          />
          <span
            class="navTitle"
            slot="title"
          >{{item.title}}</span>
        </el-menu-item>
      </el-menu>
      <div class="sidebar-footer">
        <div class="divider" />
        <el-menu
          v-if="isAuthenticated"
          router
          :collapse-transition="false"
          :collapse="collapse"
          :default-active="active"
          class="menu"
        >
          <el-menu-item
            :class="['menuItem', {folder: collapse, unfolder: !collapse}]"
            index="Notification"
            :route="{name:  'Notification'}"
          >
            <img
              src="@assets/codeScan/notification-icon.png"
              alt="NOTIFICATION"
            />
            <span
              slot="title"
              class="navTitle"
            >{{ $t('sidebarMenu.notification') }}</span>
          </el-menu-item>
          <el-menu-item
            :class="['menuItem', {folder: collapse, unfolder: !collapse}]"
            index="Settings"
            v-if="isSaas"
            :route="{name: 'Settings'}"
          >
            <img
              src="@assets/codeScan/settings-icon.png"
              alt="SETTINGS"
            />
            <span
              slot="title"
              class="navTitle"
            >{{ $t('sidebarMenu.settings') }}</span>
          </el-menu-item>
          <el-menu-item
            v-if="!hasAccess && isAuthenticated"
            :class="['menuItem', {folder: collapse, unfolder: !collapse}]"
            index="Request"
            :route="{name: 'Request'}"
          >
            <img
              src="@assets/codeScan/key.png"
              alt="REQUEST"
            />
            <span
              slot="title"
              class="navTitle"
            >{{ $t('sidebarMenu.request') }}</span>
          </el-menu-item>
        </el-menu>
        <div :class="['menuItem menu footerItem',{folder: collapse, unfolder: !collapse}]">
          <UserButton
            :collapse="collapse"
            v-if="isAuthenticated"
          >{{$t('sidebarMenu.signIn')}}</UserButton>
          <SignIn
            :is-saas="isSaas"
            :collapse="collapse"
            v-else
          />
        </div>
      </div>
      <div
        class="divider"
        v-if="isSaas"
      />
      <el-dropdown
        v-if="isSaas"
        class="language-dropdown"
        trigger="click"
        placement="top"
        @command="handleLanguageChange"
      >
        <span class="el-dropdown-link">
          {{ currentLanguage }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="en">English</el-dropdown-item>
          <el-dropdown-item command="zh">中文</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div class="divider" />
      <div
        class="folderWrapper"
        @click="toggleSidebar"
      >
        <img
          :class="['folderImg', {unfolderImg: collapse}]"
          src="@assets/icon/double-arrow-left.png"
          alt=""
        >
      </div>
    </div>
  </el-aside>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import UserButton from './user-button.vue';
import SignIn from './sign-in.vue';

export default {
  name: 'SidebarMenu',
  props: {
    isSaas: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    UserButton,
    SignIn,
  },
  data() {
    return {
      collapse: false,
      active: '',
      menus: this.isSaas
        ? [
            {
              index: 'Document',
              title: this.$t('sidebarMenu.documentation'),
              iconImg: require('@assets/codeScan/code_scan_there.png'),
              route: { name: 'Document' },
            },
            {
              index: 'LoopholeScan',
              title: this.$t('sidebarMenu.codeScan'),
              iconImg: require('@assets/codeScan/code_scan_index.png'),
              route: { name: 'LoopholeScan' },
            },
            {
              index: 'ReportsIndex',
              title: this.$t('sidebarMenu.reports'),
              iconImg: require('@assets/codeScan/code_scan_sj.png'),
              route: { name: 'ReportsIndex' },
            },
          ]
        : [
            {
              index: 'LoopholeScan',
              title: this.$t('sidebarMenu.codeScan'),
              iconImg: require('@assets/codeScan/code_scan_index.png'),
              route: { name: 'LoopholeScan' },
            },
            {
              index: 'ReportsIndex',
              title: this.$t('sidebarMenu.reports'),
              iconImg: require('@assets/codeScan/code_scan_sj.png'),
              route: { name: 'ReportsIndex' },
            },
          ],
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        this.active = to.name;
      },
    },
  },
  computed: {
    ...mapGetters('user', ['hasAccess', 'isAuthenticated']),
    ...mapGetters('common', ['locale']), // 从 common store 获取 locale
    width() {
      return this.collapse ? '80px' : '220px';
    },
    currentLanguage() {
      const enTitle = this.collapse ? 'EN' : 'English';
      return this.locale === 'en' ? enTitle : '中文';
    },
  },
  methods: {
    ...mapActions('common', ['setLocale']),
    toggleSidebar() {
      this.collapse = !this.collapse;
    },
    handleLanguageChange(lang) {
      this.setLocale(lang);
      this.refreshPage();
    },
    refreshPage() {
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  position: relative;
  border-radius: 10px;
  margin: 20px 0 20px 20px;
  padding: 4px 0;
  background: #fff;
}

.language-dropdown {
  height: 40px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}

.main {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.divider {
  margin: 4px auto;
  height: 1px;
  background: #ebeef5;
  width: 80%;
}

.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 56px;

  img {
    width: 120px;
    height: fit-content;
  }

  .logoImg-s {
    width: 24px;
    height: fit-content;
  }
}

.menu {
  border: none;
}

.menu img {
  width: 24px;
  height: 24px;
}

.navTitle {
  margin-left: 16px;
}

.menuItem {
  &.folder {
    display: flex;
    justify-items: center;
    align-items: center;
    text-align: center;
    padding: 0 !important;
  }

  &.unfolder {
    padding-left: 43px !important;
  }

  &:focus {
    background: #fff;
  }

  &.is-active,
  &.is-active:focus {
    background: #f5f7fa;
    color: #000;
    font-weight: bold;
  }
}

.sidebar-footer {
  display: flex;
  flex-direction: column;
  margin: auto 0 0;
}

.link {
  color: #2b2b2b;
  text-decoration: none;
}

.router-link-active {
  color: #2b2b2b;
  font-weight: bold;
}

.footerItem {
  display: flex;
  align-items: center;
  height: 56px;
}

.el-menu--collapse {
  width: auto;
}

.logo,
.folderWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 56px;

  .folderImg {
    width: 20px;
    height: 20px;
  }

  .unfolderImg {
    transform: rotate(180deg);
  }

  .foldIcon {
    font-size: 20px;
    color: #2b2b2b;
  }

  .folderWrapper {
    &:hover {
      outline: 0;
      background-color: #ecf5ff;
    }
  }
}
</style>
